export default "__VITE_ASSET__CBl9qS_x__"